import type { CSSProperties } from "react";
import { cx } from "./cx";
import s from "./skeleton.module.css";

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: CSSProperties;
}

/** A shimmering block. Decorative: put `aria-busy` on the surrounding region. */
export function Skeleton({ width = "100%", height = 14, className, style }: SkeletonProps) {
  return <div className={cx(s.sk, className)} style={{ width, height, ...style }} data-skeleton="" aria-hidden="true" />;
}
